import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "flex lg:items-center md:items-center items-start justify-between mb-1" }
const _hoisted_3 = { class: "font-bold lg:mr-0 md:mr-0 mr-2 break-all lg:w-auto md:w-auto w-auto flex-1 noresi" }
const _hoisted_4 = { class: "flex items-center justify-between mb-2" }
const _hoisted_5 = { class: "detail-route flex items-center" }
const _hoisted_6 = {
  key: 0,
  class: "mr-2 color-blue-grey-darken-1 font-bold lg:text-base md:text-base text-sm"
}
const _hoisted_7 = { class: " px-2 rounded-md lg:text-sm md:text-sm text-xs" }
const _hoisted_8 = { class: "flex flex-row items-center justify-between pt-2" }
const _hoisted_9 = { class: "flex flex-row justify-between lg:items-center md:items-center items-start lg:w-auto md:w-auto w-full md:divide-x md:divide-green-500" }
const _hoisted_10 = { class: "flex md:w-auto md:mr-2" }
const _hoisted_11 = { class: "lg:px-1 my-1 lg:w-auto px-1" }
const _hoisted_12 = {
  class: "px-2 inline-block rounded-md font-semibold text-base color-green-darken-1",
  style: {"background-color":"#E8F5E9","color":"rgb(84, 110, 122)","border":"1px solid rgb(67, 160, 71)"}
}
const _hoisted_13 = { class: "lg:px-1 my-1 lg:w-auto px-1" }
const _hoisted_14 = {
  class: "px-2 inline-block rounded-md font-semibold text-base",
  style: {"background-color":"rgb(236, 239, 241)","color":"rgb(84, 110, 122)","border":"1px solid rgb(84, 110, 122)"}
}
const _hoisted_15 = { class: "flex lg:w-auto mx-2 lg:px-2 sm:my-2" }
const _hoisted_16 = { class: "font-semibold color-green-darken-3" }
const _hoisted_17 = /*#__PURE__*/_createVNode("div", { class: "icon ml-3" }, [
  /*#__PURE__*/_createVNode("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    class: ""
  }, [
    /*#__PURE__*/_createVNode("path", {
      d: "M10.2898 3.85923L1.81978 17.9992C1.64514 18.3017 1.55274 18.6445 1.55177 18.9937C1.55079 19.343 1.64127 19.6864 1.8142 19.9898C1.98714 20.2931 2.2365 20.546 2.53748 20.7231C2.83847 20.9002 3.18058 20.9954 3.52978 20.9992H20.4698C20.819 20.9954 21.1611 20.9002 21.4621 20.7231C21.7631 20.546 22.0124 20.2931 22.1854 19.9898C22.3583 19.6864 22.4488 19.343 22.4478 18.9937C22.4468 18.6445 22.3544 18.3017 22.1798 17.9992L13.7098 3.85923C13.5315 3.56533 13.2805 3.32235 12.981 3.15371C12.6814 2.98508 12.3435 2.89648 11.9998 2.89648C11.656 2.89648 11.3181 2.98508 11.0186 3.15371C10.7191 3.32235 10.468 3.56533 10.2898 3.85923V3.85923Z",
      stroke: "#F44336",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }),
    /*#__PURE__*/_createVNode("path", {
      d: "M12 9V13",
      stroke: "#F44336",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }),
    /*#__PURE__*/_createVNode("path", {
      d: "M12 17H12.01",
      stroke: "#F44336",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Card = _resolveComponent("Card")

  return (_ctx.item)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _createVNode(_component_Card, {
          class: `cursor-pointer card-no-shadow mt-2 card-item-category `,
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showDetail(_ctx.item.Id)))
        }, {
          content: _withCtx(() => [
            _createVNode("div", _hoisted_2, [
              _createVNode("h5", _hoisted_3, _toDisplayString(_ctx.item.KodeJadwal), 1)
            ]),
            _createVNode("div", _hoisted_4, [
              _createVNode("div", _hoisted_5, [
                (_ctx.item.AgenAsal && _ctx.item.AgenTujuan)
                  ? (_openBlock(), _createBlock("p", _hoisted_6, _toDisplayString(_ctx.item.AgenAsal.Nama) + " - " + _toDisplayString(_ctx.item.AgenTujuan.Nama), 1))
                  : _createCommentVNode("", true),
                _createVNode("span", _hoisted_7, _toDisplayString(_ctx.moment(_ctx.item.TanggalAktif).format('DD MMMM YYYY')), 1)
              ])
            ]),
            _createVNode("div", _hoisted_8, [
              _createVNode("div", _hoisted_9, [
                _createVNode("div", _hoisted_10, [
                  _createVNode("div", _hoisted_11, [
                    _createVNode("p", _hoisted_12, _toDisplayString(_ctx.item.Rit?`Rit ${_ctx.item.Rit}`:''), 1)
                  ]),
                  _createVNode("div", _hoisted_13, [
                    _createVNode("p", _hoisted_14, _toDisplayString(_ctx.item.Kode), 1)
                  ])
                ]),
                _createVNode("div", _hoisted_15, [
                  _createVNode("span", _hoisted_16, "Sudah Dicek : " + _toDisplayString(_ctx.item.DoneScan) + "/" + _toDisplayString(_ctx.item.NotDoneScan+_ctx.item.DoneScan), 1),
                  _hoisted_17
                ])
              ])
            ])
          ]),
          _: 1
        })
      ]))
    : _createCommentVNode("", true)
}